import endpoints from '../../configurations/endpoints';
import { callEndpoint } from '../backend';
import { identify } from '../event-capture';
import { listenerMiddleware, startAppListening } from './listenerMiddleware';

export const middleware = () => {
  startAppListening({
    // Can match against actions _or_ state changes/contents
    predicate: (action, currentState, previousState) =>
      currentState?.backendService?.currentMember?.id !==
      previousState.backendService?.currentMember?.id,

    effect: async (action, listenerApi) => {
      const state = listenerApi.getState();
      const currentMember = state?.backendService?.currentMember;

      if (!currentMember) {
        return;
      }

      const memberDetails = await callEndpoint(endpoints.getMember, {
        memberId: currentMember?.id,
      });

      identify({
        ...memberDetails,
        ...currentMember,
      });
    },
  });
  return listenerMiddleware;
};
